module.exports = __webpack_public_path__ + "static/media/sort-black.1f42a9a6.svg";